import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/cms/blog', request)
}

export {get}
